import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Form, FormGroup, Label, Input} from "reactstrap";
import "../styles/Addproduct.css";

const ProductForm = () => {
  const [newProduct, setNewProduct] = useState({
    name: "",
    category: "",
    brand: "",
    reference: "",
    quantity: "",
    compost: false,
    value: null,
    image: null,
  });

  const [imageFile, setImageFile] = useState(null);

  // Function to handle form input changes
  const handleInputChange = (e) => {
    setNewProduct({...newProduct,[e.target.name]: e.target.value})

    console.log(newProduct)

  };

  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("name", newProduct.name);
      formData.append("category", newProduct.category);
      formData.append("brand", newProduct.brand);
      formData.append("reference", newProduct.reference);
      formData.append("quantity", newProduct.quantity);
      formData.append("compost", newProduct.compost);
      formData.append("value", newProduct.value);
      formData.append("image", imageFile); // Use the selected image file
  
      const response = await fetch(
        "https://hidden-hill-6661.fly.dev/products/add",
        {
          method: "POST",
          body: formData,
        }
      );
  
      if (response.ok) {
        const newProductData = await response.json();
        setNewProduct({
          name: "",
          category: "",
          brand: "",
          reference: "",
          quantity: "",
          description:"",
          compost: false,
          value: null,
          image: null,
        });
      }
    } catch (error) {
      console.error("Error adding product:", error);
    }
  };
  
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setImageFile(file);
  };

  return (
    <Container fluid className="product-form">
      <h2>Agregar Producto</h2>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
        <div>
          <Label htmlFor="name">Nombre:</Label>
          <Input
            type="text"
            id="name"
            name="name"
            value={newProduct.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="category">Categoria:</Label>
          <Input
            type="text"
            id="category"
            name="category"
            value={newProduct.category}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="description">Descripción:</Label>
          <Input
            type="text"
            id="description"
            name="description"
            value={newProduct.description}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="brand">Marca:</Label>
          <Input
            type="text"
            id="brand"
            name="brand"
            value={newProduct.brand}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="value">Valor:</Label>
          <Input
            type="number"
            id="value"
            name="value"
            value={newProduct.value}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="reference">Referencia:</Label>
          <Input
            type="text"
            id="reference"
            name="reference"
            value={newProduct.reference}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="compost">Compuesto:</Label>
          <Input
            type="select"
            id="compost"
            name="compost"
            value={newProduct.compost}
            onChange={handleInputChange}
          >
            <option value={true}>si</option>
            <option value={false}>no</option>
          </Input>
        </div>
        <div>
          <Label htmlFor="quantity">Cantidad:</Label>
          <Input
            type="number"
            id="quantity"
            name="quantity"
            value={newProduct.quantity}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <Label>Imagen:</Label>
          <Input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
        <button onClick={handleSubmit} type="submit">Guardar</button>
      </FormGroup>
      </Form>
    </Container>
  );
};

export default ProductForm;
